import React from 'react'
import { Skeleton, Card, Box, Stack, Grid2 } from '@mui/material'

const LoadingSkeleton = () => {
  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12, md: 4 }}>
        <Card sx={{ p: 3, textAlign: 'center', height: '100%' }}>
          <Skeleton
            variant='text'
            width='60%'
            height={24}
            sx={{ mx: 'auto' }}
          />
          <Skeleton
            variant='text'
            width='80%'
            height={18}
            sx={{ mx: 'auto', mb: 2 }}
          />
          <Box
            sx={{
              my: { xs: 2, md: 3 },
              height: 215,
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <Skeleton variant='rectangular' width={215} height={215} />
          </Box>
          <Skeleton
            variant='text'
            width='40%'
            height={18}
            sx={{ mx: 'auto', mb: 2 }}
          />
          <Stack alignItems='center'>
            <Skeleton width={120} height={40} />
          </Stack>
        </Card>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 8 }}>
        <Stack spacing={3}>
          <Card sx={{ p: 3 }}>
            <Skeleton variant='text' width='50%' height={24} />
            <Skeleton width='100%' height={56} />
            <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
              <Skeleton width={120} height={40} />
            </Stack>
          </Card>
          <Card sx={{ p: 3 }}>
            <Skeleton variant='text' width='50%' height={24} />
            <Skeleton width='100%' height={56} />
            <Stack spacing={3} sx={{ mt: 3, alignItems: 'flex-end' }}>
              <Skeleton width={120} height={40} />
            </Stack>
          </Card>
        </Stack>
      </Grid2>
    </Grid2>
  )
}

export default LoadingSkeleton
